import {Divider, ListItem, Stack, Typography} from "@mui/material";
import {Notification} from "../../../utils/models/Notification";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import DialogOpenNotification from "../../dialog/DialogOpenNotification";
import moment from "moment";
import "moment/locale/de";
import "moment/locale/it";
import {momentRelativeTimeTranslationsForLocale} from "../../../utils/helpers/datesHelper";

interface Props {
    style: any;
    notification: Notification;
    index: number;
    length: number;
}

type SupportedLocale = 'fr' | 'de' | 'it';

export default function NotificationItem({style, notification, index, length}: Props) {
    const {t, i18n} = useTranslation();
    const currentLocale = i18n.language as SupportedLocale;
    const [openDialog, setOpenDialog] = useState<boolean>(false);

    moment.locale(currentLocale, momentRelativeTimeTranslationsForLocale(currentLocale));
    const date = moment(notification.dispatched).fromNow();

    return (
        <>
            {openDialog &&
                <DialogOpenNotification notification={notification} open={openDialog} handleClose={() => setOpenDialog(false)} />
            }
            <ListItem
                style={style}
                onClick={() => {
                    setOpenDialog(true);
                }}
                sx={{
                    backgroundColor: index % 2 ? "#f5f1e9" : "white",
                    "&.Mui-selected": {
                        backgroundColor: "#f294b4"
                    },
                    "&.Mui-focusVisible": {
                        backgroundColor: "#f294b4"
                    },
                    ":hover": {
                        backgroundColor: "white"
                    }
                }}>
                <Stack direction='column'>
                    <Typography
                        variant={"body1"}>
                        {notification.notification.title[`${currentLocale}`]}
                    </Typography>
                    <Typography
                        variant={"body1Bold"}>
                        {date}
                    </Typography>
                    {notification.personalReferences &&
                        <Typography
                            variant={"body1"}>
                            {
                                t("notification_item_users", {
                                    users: notification.personalReferences.length ?? '{{users}}'
                                })
                            }
                        </Typography>
                    }
                </Stack>
            </ListItem>
            {index !== length - 1 &&
                <Divider/>
            }
        </>
    )
}